module.exports = __webpack_public_path__ + "static/2front-outsource-3-5e80f39608c74239c3d174d820bc27b8.png";